// @flow

import * as React from 'react'
import { connect, type Connector } from 'react-redux'
import NotificationSystem from 'react-notification-system'
import { resetNotification } from '../store/notification-manager'
import type { ReduxState, Dispatch } from '../store'

type OwnProps = {||}

type MappedProps = {|
  notificationType: $PropertyType<$PropertyType<ReduxState, 'notificationManager'>, 'type'>,
  notificationMessage: string,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  return {
    notificationType: state.notificationManager.type,
    notificationMessage: state.notificationManager.message,
  }
}

type AddNotificationParams = {|
  position: 'tr',
  title: string,
  message: string,
  autoDismiss: number,
  level: string,
|}

type NotificationSystemComponent = React.Node & { addNotification: AddNotificationParams => void }

type Props = {| dispatch: Dispatch |} & OwnProps & MappedProps

class Notification extends React.Component<Props> {
  static defaultProps = {}
  notificationSystem: ?NotificationSystemComponent

  componentDidUpdate() {
    if (!this.notificationSystem) return
    switch (this.props.notificationType) {
      case 'ERROR':
        this.notificationSystem.addNotification({
          position: 'tr',
          title: 'Errore',
          message: this.props.notificationMessage,
          autoDismiss: 3,
          level: 'error',
        })
        this.props.dispatch(resetNotification())
        break
      case 'SUCCESS':
        this.notificationSystem.addNotification({
          position: 'tr',
          title: 'Successo',
          message: this.props.notificationMessage,
          autoDismiss: 3,
          level: 'success',
        })
        this.props.dispatch(resetNotification())
        break
      default:
        return
    }
  }

  render() {
    var style = {
      Containers: {
        DefaultStyle: {
          marginTop: '6.5ex',
          marginRight: '2ex',
        },
      },
    }
    return (
      <NotificationSystem
        ref={ns => {
          this.notificationSystem = ns
        }}
        style={style}
      />
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(Notification)



// WEBPACK FOOTER //
// ./src/systemwide/notification-manager.js